<template>
  <div class="position-detail-wrap">
    <van-loading type="spinner" v-if="loading" vertical class="loading" />
    <div class="position-detail-box" v-if="positionDetail && !loading">
      <notice-tips :noticeData="noticeData" v-if="noticeData"></notice-tips>
      <div class="position-detail-content">
        <div class="position-info clearfix">
          <p class="id">#{{positionDetail.positionId}}</p>
          <h1 class="title">{{positionDetail.positionTitle}}</h1>
          <position-tags class="tag-list" :position="detailTags" v-if="detailTags.positionTags && detailTags.positionTags.length"></position-tags>
          <div class="separate-info-list">
            <span class="cities" v-if="allCities && allCities.length">{{allCities.join(',')}}</span>
            <span v-if="positionDetail.headCount > 0">{{positionDetail.headCount}}人</span>
          </div>
          <div class="separate-info-list">
            <span v-if="positionDetail.degreeRequiredStr">{{positionDetail.degreeRequiredStr}}</span>
            <span v-if="positionDetail.workExpYearDesc">{{positionDetail.workExpYearDesc}}</span>
            <span v-if="positionDetail.annualSalaryDesc">
              {{positionDetail.annualSalaryDesc}}万
              <!--<span v-if="positionDetail.monthSalaryRuleView">({{positionDetail.monthSalaryRuleView}})</span>-->
            </span>
          </div>
          <div class="separate-info-list">
            <span>
              佣金：
              <span class="red">{{positionDetail.rewardViewDesc}}</span>
            </span>
            <!--{{positionDetail.rewardType == 0 ? "固定" : "预计"}}-->
            <span v-if="positionDetail.guaranteeType == 1">保证期：{{positionDetail.guaranteeTime | guaranteeTime}}</span>
            <span v-if="positionDetail.guaranteeType == 2">保证期：{{positionDetail.guaranteeTime?positionDetail.guaranteeTime +'天':'无'}}</span>
          </div>
        </div>
        <company
          v-if="positionDetail.enterprise"
          :company="positionDetail.enterprise"
          :has-arrow="true"
        ></company>
      </div>
      <div class="position-detail-content">
        <div class="position-data-wrap">
          <ul class="position-data-info" v-if="positionStatistics">
            <li>
              <span
                :class="positionStatistics.grade == 1 ? 'green' : (positionStatistics.grade == 2 ? 'orange' : 'red')"
              >{{positionStatistics.grade | gradeLevel}}</span>
              <p>做单指数</p>
            </li>
            <li>
              <span>{{positionStatistics.hhNum || "--"}}</span>
              <p>做单猎头</p>
            </li>
            <li>
              <span>{{positionStatistics.evaluateNum || "--"}}</span>
              <p>有效推荐</p>
            </li>
            <li>
              <span>{{positionStatistics.interviewNum || "--"}}</span>
              <p>面试中</p>
            </li>
          </ul>
          <div class="separate-info-list" style="padding-top: 10px">
            <span v-if="positionDetail.publishTime">{{positionDetail.publishTime | date}}发布</span>
            <span v-if="positionDetail.refreshTime">{{positionDetail.refreshTime}}更新</span>
            <span
              v-if="positionDetail.recommendFeedbackTime"
            >{{positionDetail.recommendFeedbackTime | withdrawFeedbackTime}}反馈</span>
            <span v-else>3天反馈</span>
          </div>
        </div>
      </div>
      <div v-if="pageType == 1">
        <div class="position-detail-content">
          <a :href="'/hh-wx/portraitLens/' + positionDetail.positionId" class="position-link">
            <span>
              <van-icon :name="fdj" color="#999" style="vertical-align: -1px" />职位透镜
            </span>
            <van-icon name="arrow" class="info-arrow" />
          </a>
        </div>
        <tabs
          :data="positionDetail"
          :id="positionDetail.positionId"
          :eId="positionDetail.enterprise.enterpriseId"
          :positionStatistics="positionStatistics"
        ></tabs>
        <div class="btn-wrap">
          <div class="btn-tips" @click="showTips = !showTips" v-if="showBtn && showTips">
            <p>
              点击职位打包后可以在PC端职位页AI做单中心里找到打包的职位，并进行编辑推荐！
              <span class="red fr">关闭</span>
            </p>
          </div>
          <van-button
            type="primary"
            plain
            size="normal"
            class="btn"
            @click="toggleFocus(positionDetail.isFollow)"
          >
            {{positionDetail.isFollow ? "取消关注" :
            "关注"}}
          </van-button>
          <van-button
            type="primary"
            :plain="showBtn"
            size="normal"
            class="btn"
            @click="showSpa = true"
          >联系PA</van-button>
          <van-button type="primary" size="normal" class="btn" v-if="showBtn" @click="packingBag">职位打包</van-button>
        </div>
      </div>
      <div v-if="pageType == 2">
        <portrait :pid="positionDetail.positionId" v-if="positionDetail.positionId" :pageType="2"></portrait>
      </div>
      <!--联系SPA弹出层-->
      <van-popup v-model="showSpa" position="bottom">
        <pop-spa
          @close="showSpa=false"
          :spa="positionDetail.spaViews && positionDetail.spaViews.length > 0 ? positionDetail.spaViews[0] : {}"
        ></pop-spa>
      </van-popup>
    </div>
  </div>
</template>

<script>
import fdj from "@/assets/fdj.png";
import NoticeTips from "../noticeTips";
import Company from "../company/company";
import Tabs from "./tabs";
import popSpa from "../popSpa";
import Portrait from "../../views/positions/portraitLens"
import PositionTags from "./positionTags";
import {
  getPositionDetail,
  getPositionStatistics,
  followPosition,
  unfollowPosition,
  getBroadcast,
  getPositionTags,
  testBag,
  packBag
} from "@/api/positions";
import { changeHomoReadStatus } from "@/api/aiMatch";
import { firstReadPositionBag } from "@/api/pa";


export default {
  components: { popSpa, Tabs, Company, NoticeTips , Portrait , PositionTags},
  props: {
    // pageType 1 默认详情  pageType2 带透镜对外宣传的详情
    pageType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      fdj: fdj,
      query: this.$route.query,
      loading: false,
      showSpa: false,
      showBtn: false,
      showTips: true,
      focusFlag: false,
      noticeData: null,
      positionDetail: null,
      positionStatistics: null,
      detailTags:{},
      allCities:[]
    };
  },
  methods: {
    getLocations(detail){
        let locations = detail.locations || [];
        locations.forEach((cols, index) => {
            this.allCities.push(cols.workCityName);
        });
    },
    init() {
      this.getDetail(this.query);
      getPositionTags({positionIds: this.query.positionId }).then(res=>{
          if(res.data[this.query.positionId]){
            // this.detailTags = {};
            this.detailTags.positionTags = res.data[this.query.positionId];
          }
      }).catch(err=>{});
      getBroadcast(this.query).then(res => {
        //职位公告
        if (res && res.data) {
          this.noticeData = res.data || null;
        }
      });

      if (this.$route.query.homoId) {
        changeHomoReadStatus({ homoId: this.$route.query.homoId })
          .then(res => {})
          .catch(err => {});
      }

      if (this.$route.query.positionBagId) {
        firstReadPositionBag({ positionBagId: this.$route.query.positionBagId })
          .then(res => {})
          .catch(err => {});
      }
    },
    getDetail(query) {
      this.loading = true;
      getPositionDetail(query).then(res => {
        //职位详情
        if (res && res.data) {
          this.loading = false;

          res.data.businessReqResult = res.data.businessReqResult
            ? JSON.parse(res.data.businessReqResult)
            : [];
          let desc1 = "";
          let desc2 = "";
          res.data.businessReqResult.forEach(item => {
            if (item.propertyWeight == 4) {
              desc1 = "看" + item.propertyValue;
            }
            if (item.propertyWeight == 5) {
              desc2 = "不看" + item.propertyValue;
            }
          });
          res.data.businessReqResultDesc =
            desc1 && desc2 ? desc1 + ",但" + desc2 : desc1 || desc2;

          if (res.data.positionSurvey) {
            let temp = res.data.positionSurvey;
            res.data.positionSurvey.punchCard =
              temp.punchCard == null ? null : temp.punchCard ? 1 : 2;

            let am =
              temp.workHoursAm === null
                ? null
                : new Date(parseInt(temp.workHoursAm));
            let pm =
              temp.workHoursPm === null
                ? null
                : new Date(parseInt(temp.workHoursPm));

            if (am && pm) {
              let ah =
                  (am.getHours() + "").length == 1
                    ? "0" + am.getHours()
                    : am.getHours(),
                at =
                  (am.getMinutes() + "").length == 1
                    ? "0" + am.getMinutes()
                    : am.getMinutes(),
                as =
                  (am.getSeconds() + "").length == 1
                    ? "0" + am.getSeconds()
                    : am.getSeconds(),
                ph =
                  (pm.getHours() + "").length == 1
                    ? "0" + pm.getHours()
                    : pm.getHours(),
                pt =
                  (pm.getMinutes() + "").length == 1
                    ? "0" + pm.getMinutes()
                    : pm.getMinutes(),
                ps =
                  (pm.getSeconds() + "").length == 1
                    ? "0" + pm.getSeconds()
                    : pm.getSeconds();

              res.data.positionSurvey.workHours =
                ah + ":" + at + ":" + as + "-" + ph + ":" + pt + ":" + ps;
            } else {
              res.data.positionSurvey.workHours = "";
            }
          }

          this.positionDetail = res.data || null;
          this.getLocations(this.positionDetail);
          // console.log(this.positionDetail,'ffff')
          this.$store.commit("comp/WX_SHARE", {
            title:
              "猎上职位 - " + res.data.positionTitle + " - " + res.data.city,
            link: window.location.href
          });
        }
      });
      this.getStatistics(query);
      this.isBag();
    },
    getStatistics(query) {
      let params = {
        positionIds: query.positionId
      };
      getPositionStatistics(params).then(res => {
        //职位统计
        if (res && res.data) {
          this.positionStatistics = res.data[query.positionId] || null;
        }
      });
    },
    isBag() {
      let params = { ...this.$route.params };
      params.sourceId = this.$route.query.talentId;
      this.showBtn = false;
      if (this.$route.query.talentId) {
        testBag(params).then(res => {
          //判断职位是否打包
          if (res && res.data && res.data.result) {
            this.showBtn = false;
          } else {
            this.showBtn = true;
          }
        });
      }
    },
    packingBag() {
      let params = { ...this.$route.params };
      params.sourceId = this.$route.query.talentId;
      packBag(params).then(res => {
        //职位打包
        if (res && res.data) {
          this.showBtn = false;
          this.$toast({
            type: "success",
            message: "恭喜你，职位打包成功"
          });
        }
      });
    },
    toggleFocus(f) {
      if (!f) {
        followPosition(this.query).then(res => {
          if (res && res.data) {
            this.positionDetail.isFollow = !this.positionDetail.isFollow;
            this.$toast({
              type: "html",
              message: '<h2>已关注 <br>请到猎上网PC端“我的关注"查看</h2>',
              icon: "success"
            });
          }
        });
      } else {
        unfollowPosition(this.query).then(res => {
          if (res && res.data) {
            this.positionDetail.isFollow = !this.positionDetail.isFollow;
            this.$toast({
              type: "html",
              message: "<h2>已取消关注</h2>",
              icon: "success"
            });
          }
        });
      }
    }
  },
  watch: {
    $route(n, o) {
      if (n.params.positionId != o.params.positionId) {
        n.query.positionId = n.params.positionId;
        this.query = n.query;
        this.getDetail(this.query);
      }
    }
  },
  created() {
    this.query.positionId = this.$route.params.positionId;
    this.init();
  }
};
</script>

<style scoped lang="scss">
.position-detail-wrap {
  height: 100%;
  .loading {
    top: 50%;
    transform: translateY(-50%);
  }
}
.position-detail-box {
  padding-bottom: 64px;

  .position-detail-content {
    padding: 0 15px;
    background-color: #fff;
    margin-bottom: 10px;

    .position-info {
      padding: 15px 0;
      border-bottom: 0.5px solid #e5e5e5;

      .id {
        color: #999;
        font-size: 12px;
      }

      .title {
        font-size: 16px;
      }

      .separate-info-list {
        margin-top: 10px;
        
        & > span {
          max-width: 100%;
        }
        .cities {
            
          white-space: normal;
          max-width: 80%;

        }
      }
    }

    .position-data-wrap {
      .position-data-info {
        border-bottom: 0.5px solid #e5e5e5;
        display: flex;
        padding: 10px 0;
        margin-bottom: 10px;
        justify-content: center;
        align-items: center;
        font-size: 13px;

        li {
          flex: 1;
          text-align: center;
          white-space: nowrap;

          span {
            display: inline-block;
          }

          p {
            font-size: 12px;
            color: #666;
            margin-top: 5px;
          }
        }
      }

      .separate-info-list {
        float: none;
        font-size: 12px;
        color: #333;
        justify-content: center;
        padding-bottom: 10px;
      }
    }

    .position-link {
      line-height: 50px;
      font-size: 16px;
      color: #333;
      display: flex;
      align-items: center;

      .info-arrow {
        margin-left: auto;
        font-size: 20px;
        color: #999;
      }
    }
  }

  .btn-wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 15px;
    background-color: #fafafa;
    z-index: 1000;
    .btn-tips {
      width: 210px;
      position: absolute;
      bottom: 65px;
      right: 15px;
      box-shadow: 0 2px 8px 0 rgba(227, 204, 110, 0.47);
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #333333;
      line-height: 20px;
      text-align: left;
      p {
        background: #fff8de;
        padding: 5px 10px 10px;
        position: relative;
        z-index: 10;
      }
      &:after {
        content: " ";
        width: 8px;
        height: 8px;
        transform: rotate(45deg);
        position: absolute;
        bottom: -5px;
        right: 80px;
        background: #fff8de;
        box-shadow: 0 2px 8px 0 rgba(227, 204, 110, 0.47);
      }
    }
  }
}
</style>
